import "toastr/build/toastr.min.css";
import { toast } from "react-toastify";
import {
    CALL_DETAILS,
  CANDIDATE,
  CANDIDATE_CALLBACK,
  CANDIDATE_CSV,
  CANDIDATE_FADV,
  CANDIDATE_FADV_PROFILE,
  COMMON,
  HIRE_STATUS,
  VERIFY_APPLICATION_FILE,
} from "../config/apiEndPoint";
import { GET, MULTIPART_POST, MULTIPART_PUT, POST, PUT } from "config/api.config";

export const getCandidateMetadata = async () => {
  try {
    const response = await GET(CANDIDATE.GET_METADATA);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const submitCandidateFilterData = async (data = {}) => {
  try {
    const response = await POST(CANDIDATE.SUBMIT_FILTER_DATA, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** POST `Candidate/header-search` — global header candidate lookup. */
export const headerSearchCandidates = async (data = {}) => {
  try {
    const response = await POST(CANDIDATE.HEADER_SEARCH, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const addCandidate = async (data = {}) => {
  try {
    const response = await MULTIPART_POST(CANDIDATE.ADD_CANDIDATE, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const updateCandidate = async (id = "", data = {}) => {
  try {
    const url = `${CANDIDATE.UPDATE_CANDIDATE}/${id}`;
    const response = await MULTIPART_PUT(url, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** GET `Candidate/clients/{clientId}/jobs` — Position Applied options for candidate add/edit. */
export const getCandidateClientJobs = async (clientId = "") => {
  const id = String(clientId || "").trim();
  if (!id) return null;
  try {
    const response = await GET(CANDIDATE.GET_CLIENT_JOBS(id));
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const resetCandidate = async (id = "") => {
  try {
    const url = `Candidate/${id}/reset`;
    const response = await POST(url);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** POST `Candidate/{id}/todaycall` */
export const candidateTodayCall = async (id = "") => {
  try {
    const response = await POST(CANDIDATE.TODAY_CALL(id));
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** POST `Candidate/{id}/sureMailSend` */
export const candidateSureMailSend = async (id = "") => {
  try {
    const response = await POST(CANDIDATE.SURE_MAIL_SEND(id));
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** PUT `Candidate/closure/{id}` — body e.g. `{ userId, closedDate }` */
export const candidateClosure = async (id = "", data = {}) => {
  try {
    const candidateId = String(id || "").trim();
    const response = await PUT(CANDIDATE.CLOSURE(candidateId), data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};
export const candidateClosureSubmit = async (id = "", data = {}) => {
  try {
    const candidateId = String(id || "").trim();
    const response = await POST(CANDIDATE.CLOSURE_SUBMIT(candidateId), data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** PUT `Candidate/{id}/mark-hired` — body `{ hireDate }` */
export const candidateMarkAsHired = async (id = "", data = {}) => {
  try {
    const candidateId = String(id || "").trim();
    const response = await PUT(CANDIDATE.MARK_AS_HIRED(candidateId), data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** PUT `Candidate/{id}/mark-reject` — body `{ note, reasonId }` */
export const candidateMarkAsRejected = async (id = "", data = {}) => {
  try {
    const candidateId = String(id || "").trim();
    const response = await PUT(CANDIDATE.MARK_AS_REJECTED(candidateId), data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** POST `Candidate/{candidateClientId}/ai-recruiter-opt-in` */
export const candidateAiRecruiterOptIn = async (candidateClientId = "") => {
  try {
    const id = String(candidateClientId || "").trim();
    const response = await POST(CANDIDATE.AI_RECRUITER_OPT_IN(id));
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** POST `Candidate/{candidateClientId}/ai-recruiter-opt-out` — body `{ notes }` */
export const candidateAiRecruiterOptOut = async (candidateClientId = "", data = {}) => {
  try {
    const id = String(candidateClientId || "").trim();
    const response = await POST(CANDIDATE.AI_RECRUITER_OPT_OUT(id), data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** GET `candidate/csv/profileCSV/metadata` */
export const fetchProfileCsvMetadata = async (data = {}) => {
  try {
    const response = await GET(CANDIDATE_CSV.PROFILE_METADATA, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** POST `candidate/csv/profileCSV/upload` — multipart FormData `{ ClientId, File }`. */
export const uploadCandidateProfileCsv = async (formData) => {
  try {
    const response = await MULTIPART_POST(CANDIDATE_CSV.PROFILE_UPLOAD, formData);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** POST `candidate/csv/profileCSV/verify` — body `{ clientId, data }`. */
export const verifyCandidateProfileCsv = async (data = {}) => {
  try {
    const response = await POST(CANDIDATE_CSV.PROFILE_VERIFY, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** POST `candidate/csv/drugCSV/upload` — multipart `{ ClientId, File }`. */
export const uploadCandidateDrugCsv = async (formData) => {
  try {
    const response = await MULTIPART_POST(CANDIDATE_CSV.DRUG_UPLOAD, formData);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** POST `candidate/csv/drugCSV/verify` — body `{ orderId, clientId, items }`. */
export const verifyCandidateDrugCsv = async (data = {}) => {
  try {
    const response = await POST(CANDIDATE_CSV.DRUG_VERIFY, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** GET `candidate/csv/fadv/verify/metadata` */
export const fetchVerifyFadvCsvMetadata = async (data = {}) => {
  try {
    const response = await GET(CANDIDATE_CSV.FADV_VERIFY_METADATA, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** POST `candidate/csv/fadv/verify` — filter body e.g. `{ clientId }`. */
export const submitVerifyFadvCsvFilterData = async (data = {}) => {
  try {
    const response = await POST(CANDIDATE_CSV.FADV_VERIFY, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** @deprecated Use `submitVerifyFadvCsvFilterData`. */
export const verifyCandidateFadvCsv = submitVerifyFadvCsvFilterData;

/** POST `candidate/csv/candidate-autocomplete` — body `{ search, clientId }`. */
export const submitFadvCsvCandidateAutocomplete = async (data = {}) => {
  try {
    const response = await POST(CANDIDATE_CSV.CANDIDATE_AUTOCOMPLETE, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** POST `candidate/csv/fadv/submit` — body `{ clientId, data: [...] }`. */
export const submitVerifyFadvCsvData = async (data = {}) => {
  try {
    const response = await POST(CANDIDATE_CSV.FADV_SUBMIT, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** POST `candidate/csv/bulk-cv/upload` — multipart `{ ClientId, SourceId, Files (repeated) }`. */
export const uploadCandidateBulkCv = async (formData) => {
  try {
    const response = await MULTIPART_POST(CANDIDATE_CSV.BULK_CV_UPLOAD, formData);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/**
 * GET work experience for one candidate: **`candidate/WorkExperience/{candidateId}`** (not `call/details/driving-experience/{id}`).
 * Same URL style as `getJobCategoryDataById` in CategoryModel. Pass `{ candidateId }` (e.g. `item.candidateId`).
 */
export const getCandidateWorkExperienceByCandidateId = async (data = {}) => {
  try {
    const candidateId = String(data?.candidateId ?? "").trim();
    const requestUrl = candidateId
      ? `${CANDIDATE.GET_WORK_EXPERIENCE}/${candidateId}`
      : `${CANDIDATE.GET_WORK_EXPERIENCE}`;
    const response = await GET(requestUrl, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/**
 * PUT `candidate/WorkExperience/{candidateId}` with body:
 * `{ candidateClientId: string, items: { id, companyName, position, duration, jobType, isDeleted }[] }`.
 */
export const updateCandidateWorkExperienceByCandidateId = async (
  workExperienceCandidateId = "",
  requestBody = {}
) => {
  try {
    const candidateId = String(workExperienceCandidateId ?? "").trim();
    if (!candidateId) return undefined;
    const requestUrl = `${CANDIDATE.GET_WORK_EXPERIENCE}`;
    const response = await POST(requestUrl, requestBody);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** Bulk deactivate: POST `Candidate/deactivate` with `{ ids: string[] }`. */
export const deactivateCandidates = async (payload = {}) => {
  try {
    const response = await POST(CANDIDATE.DEACTIVATE, payload);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** Bulk transfer: POST `Candidate/bulk-transfer` with `{ ids: string[], clientId: string }`. */
export const bulkTransferCandidates = async (payload = {}) => {
  try {
    const response = await POST(CANDIDATE.BULK_TRANSFER, payload);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** Bulk move: POST `Candidate/bulk-move` with `{ candidateClientIds: string[], targetClientId: string, jobId: string }`. */
export const bulkMoveCandidates = async (payload = {}) => {
  try {
    const response = await POST(CANDIDATE.BULK_MOVE, payload);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** GET `candidate/callback/metadata` */
export const fetchCandidateCallBackMetadata = async (data = {}) => {
  try {
    const response = await GET(CANDIDATE_CALLBACK.GET_METADATA, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** POST `candidate/callback/filter` */
export const submitCandidateCallBackFilterData = async (data = {}) => {
  try {
    const response = await POST(CANDIDATE_CALLBACK.SUBMIT_FILTER_DATA, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** PUT `candidate/callback/{id}` */
export const saveCandidateCallBackRequest = async (data = {}) => {
  try {
    const id = String(data?.id || "").trim();
    const url = CANDIDATE_CALLBACK.SUBMIT(id);
    const response = await PUT(url, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** GET `candidate/verify-application-file/metadata` */
export const fetchVerifyApplicationFileMetadata = async (data = {}) => {
  try {
    const response = await GET(VERIFY_APPLICATION_FILE.GET_METADATA, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** POST `candidate/verify-application-file/filter` — body `{ fromDate, toDate }`. */
export const submitVerifyApplicationFileFilterData = async (data = {}) => {
  try {
    const response = await POST(VERIFY_APPLICATION_FILE.SUBMIT_FILTER_DATA, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** POST `candidate/verify-application-file/submit` — body `{ data: [{ fadvOrderPlaceFileId, candidateClientId }] }`. */
export const submitVerifyApplicationFileData = async (data = {}) => {
  try {
    const response = await POST(VERIFY_APPLICATION_FILE.SUBMIT, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** GET `candidate/csv/meta` */
export const fetchCandidateCsvMetadata = async (data = {}) => {
  try {
    const response = await GET(CANDIDATE_CSV.GET_METADATA, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** POST `candidate/csv/filter` */
export const submitCandidateCsvFilterData = async (data = {}) => {
  try {
    const response = await POST(CANDIDATE_CSV.SUBMIT_FILTER_DATA, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** GET `candidate/fadv/meta` */
export const fetchCandidateFadvMetadata = async (data = {}) => {
  try {
    const response = await GET(CANDIDATE_FADV.GET_METADATA, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** POST `candidate/fadv/filter` */
export const submitCandidateFadvFilterData = async (data = {}) => {
  try {
    const response = await POST(CANDIDATE_FADV.SUBMIT_FILTER_DATA, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** POST `candidate/fadv/{id}/trigger-fadv` */
export const triggerFadvApiCall = async (id = "", data = {}) => {
  try {
    const response = await POST(CANDIDATE_FADV.TRIGGER_FADV(id), data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** GET `candidate/fadv/profile/meta` */
export const fetchCandidateFadvProfileMetadata = async (data = {}) => {
  try {
    const response = await GET(CANDIDATE_FADV_PROFILE.GET_METADATA, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** POST `candidate/fadv/profile/filter` */
export const submitCandidateFadvProfileFilterData = async (data = {}) => {
  try {
    const response = await POST(CANDIDATE_FADV_PROFILE.SUBMIT_FILTER_DATA, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** POST `candidate/fadv/profile/{fadvProfileOrderDataId}/trigger` */
export const triggerFadvProfileApiCall = async (fadvProfileOrderDataId = "") => {
  try {
    const response = await POST(CANDIDATE_FADV_PROFILE.TRIGGER_FADV(fadvProfileOrderDataId));
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** GET `common/order-status` */
export const fetchCommonOrderStatusOptions = async () => {
  try {
    const response = await GET(COMMON.ORDER_STATUS);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** GET `common/hire-status-hire-status` — candidate hire status table status dropdown */
export const fetchCommonHireStatusOptions = async () => {
  try {
    const response = await GET(COMMON.HIRE_STATUS);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** GET `common/yes-no` */
export const fetchCommonYesNoOptions = async () => {
  try {
    const response = await GET(COMMON.YES_NO);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** GET `common/drug-status` — `data[]` rows: `status`, `value`, `data`, `bgColor`, `lableCss`, … */
export const fetchCommonDrugStatusOptions = async () => {
  try {
    const response = await GET(COMMON.DRUG_STATUS);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** GET `common/call-status` — options for Call Details call-status Type select */
export const fetchCommonCallStatusOptions = async () => {
  try {
    const response = await GET(COMMON.CALL_STATUS);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** POST `common/call-status-merge` — merged call status options (e.g. `{ isComplete: true }`). */
export const fetchCommonCallStatusMergeOptions = async (data = {}) => {
  try {
    const response = await POST(COMMON.CALL_STATUS_MERGE, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** GET `common/incentive-type` */
export const fetchCommonIncentiveTypeOptions = async () => {
  try {
    const response = await GET(COMMON.INCENTIVE_TYPE);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** GET `HireStatus/options/incentive-status` — candidate hire status incentive dropdown */
export const fetchHireStatusIncentiveStatusOptions = async () => {
  try {
    const response = await GET(HIRE_STATUS.GET_INCENTIVE_STATUS_OPTIONS);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** GET `HireStatus/meta` */
export const getHireStatusMetadata = async () => {
  try {
    const response = await GET(HIRE_STATUS.GET_METADATA);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** POST `HireStatus/filter` */
export const submitHireStatusFilterData = async (data = {}) => {
  try {
    const response = await POST(HIRE_STATUS.SUBMIT_FILTER_DATA, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** POST `HireStatus` — create / update hire status row. */
export const saveHireStatus = async (data = {}) => {
  try {
    const response = await POST(HIRE_STATUS.UPSERT, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** Alias for `candidateClosure` (PUT `Candidate/closure/{id}`). */
export const candidateClosureUpdate = candidateClosure;


export const getCandidateDetailsForUsingCallDetails = async (data) => {
    try {
      const response = await GET(`${CANDIDATE.GET_CANDIDATE}/${data?.candidateId}`);
      return response;
    } catch (error) {
      toast.error(error?.message);
    }
  };

  export const getCallInfo = async (data) => {
    try {
      const response = await GET(`${CALL_DETAILS.GET_CALL_INFO}/${data?.candidateId}/call-activities`);
      return response;
    } catch (error) {
      toast.error(error?.message);
    }
  };
